(function($) {
    "use strict";

    /*!
     * FitVids 1.1
     *
     * Copyright 2013, Chris Coyier - http://css-tricks.com + Dave Rupert - http://daverupert.com
     * Credit to Thierry Koblentz - http://www.alistapart.com/articles/creating-intrinsic-ratios-for-video/
     * Released under the WTFPL license - http://sam.zoy.org/wtfpl/
     *
     */
    $.fn.fitVids = function( options ) {
        var settings = {
            customSelector: null,
            ignore: null
        };

        if(!document.getElementById('fit-vids-style')) {
            // appendStyles: https://github.com/toddmotto/fluidvids/blob/master/dist/fluidvids.js
            var head = document.head || document.getElementsByTagName('head')[0];
            var css = '.fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}';
            var div = document.createElement("div");
            div.innerHTML = '<p>x</p><style id="fit-vids-style">' + css + '</style>';
            head.appendChild(div.childNodes[1]);
        }

        if ( options ) {
            $.extend( settings, options );
        }

        return this.each(function(){
            var selectors = [
                'iframe[src*="player.vimeo.com"]',
                'iframe[src*="youtube.com"]',
                'iframe[src*="youtube-nocookie.com"]',
                'iframe[src*="kickstarter.com"][src*="video.html"]',
                'object',
                'embed'
            ];

            if (settings.customSelector) {
                selectors.push(settings.customSelector);
            }

            var ignoreList = '.fitvidsignore';

            if(settings.ignore) {
                ignoreList = ignoreList + ', ' + settings.ignore;
            }

            var $allVideos = $(this).find(selectors.join(','));
            $allVideos = $allVideos.not('object object'); // SwfObj conflict patch
            $allVideos = $allVideos.not(ignoreList); // Disable FitVids on this video.

            $allVideos.each(function(){
                var $this = $(this);
                if($this.parents(ignoreList).length > 0) {
                    return; // Disable FitVids on this video.
                }
                if (this.tagName.toLowerCase() === 'embed' && $this.parent('object').length || $this.parent('.fluid-width-video-wrapper').length) { return; }
                if ((!$this.css('height') && !$this.css('width')) && (isNaN($this.attr('height')) || isNaN($this.attr('width'))))
                {
                    $this.attr('height', 9);
                    $this.attr('width', 16);
                }
                var height = ( this.tagName.toLowerCase() === 'object' || ($this.attr('height') && !isNaN(parseInt($this.attr('height'), 10))) ) ? parseInt($this.attr('height'), 10) : $this.height(),
                    width = !isNaN(parseInt($this.attr('width'), 10)) ? parseInt($this.attr('width'), 10) : $this.width(),
                    aspectRatio = height / width;
                if(!$this.attr('name')){
                    var videoName = 'fitvid' + $.fn.fitVids._count;
                    $this.attr('name', videoName);
                    $.fn.fitVids._count++;
                }
                $this.wrap('<div class="fluid-width-video-wrapper"></div>').parent('.fluid-width-video-wrapper').css('padding-top', (aspectRatio * 100)+'%');
                $this.removeAttr('height').removeAttr('width');
            });
        });
    };

    // Internal counter for unique video names.
    $.fn.fitVids._count = 0;
}(jQuery));

;(function noBSWrapper() {
    'use strict'
    /**
     * no BS slider
     * for really simple tasks
     */
    function _nobs(container, options) {
        options = options || {}

        var images = container.querySelectorAll('img')

        if (!images || !images.length) { return }

        var src = [].map.call(images, function(img) { return img.getAttribute('src') }).filter(function(img) { return Boolean(img) })
        var total = src.length

        // containers
        options.contain && container.classList.add('nobs-slider--contain')
        var viewport = document.createElement('div')
        viewport.className = 'nobs-slider__viewport'
        var holder = document.createElement('div')
        holder.className = 'nobs-slider__holder'
        var prev = document.createElement('span')
        prev.className = 'nobs-slider__prev'
        prev.innerHTML = options.prev || '<'
        var next = document.createElement('span');
        next.className = 'nobs-slider__next';
        next.innerHTML = options.next || '>';

        // runtime vars
        var current = 0
        var animationHandle = null
        var animationInterval = options.delay || 3000

        // markup
        src.forEach(function(item) {
            var slide = document.createElement('div')
            slide.className = 'nobs-slider__item'
            slide.style.backgroundImage = 'url(' + item + ')'
            holder.appendChild(slide)
        })

        viewport.appendChild(holder)
        viewport.appendChild(prev)
        viewport.appendChild(next)
        container.appendChild(viewport)

        // gets next frame index
        function getNext() {
            current = current + 1 >= total ? 0 : current + 1
        }

        // gets previous frame index
        function getPrev() {
            current = current - 1 < 0 ? total - 1 : current - 1
        }

        // moves frame to new position
        function animate() {
            holder.style.transform = 'translate3d(' + (-1 * 100 * current) + '%,0,0)'
        }

        // stops autoplay
        function stop() {
            animationHandle && clearTimeout(animationHandle)
        }

        // resumes or starts autoplay
        function play() {
            stop()
            animationHandle = setInterval(function() {
                getNext()
                animate()
            }, animationInterval)
        }

        // moves to new frame
        function _move(changeFrame) {
            stop()
            changeFrame()
            animate()
            play()
        }

        // events
        prev.addEventListener('click', _move.bind(null, getPrev))
        next.addEventListener('click', _move.bind(null, getNext))

        // start
        play()
    }

    window.nobs = function(selector, options) {
        var matchedElements = document.querySelectorAll(selector)
        matchedElements = matchedElements && [].map.call(matchedElements, function(item) { return item })
        if (!matchedElements || !matchedElements.length) { return }
        matchedElements.forEach(function(container) {
            var sliders = container.querySelectorAll('.fn-nobs-slider')
            sliders = sliders && [].forEach.call(sliders, function(slider) { _nobs(slider, options) } )
        })
    }
}());

/**
 * Project: Minerva KB
 * Copyright: 2015-2016 @KonstruktStudio
 */
(function ($) {
    "use strict";

    var GLOBAL_DATA = window.MinervaKB;

    var i18n = GLOBAL_DATA.i18n;
    var platform = GLOBAL_DATA.platform;
    var settings = GLOBAL_DATA.settings;
    var info = GLOBAL_DATA.info;
    var $body = $('body');

    /**
     * libs
     */
    if (!String.prototype.trim) {
        String.prototype.trim = function () {
            return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        };
    }

    /**
     * Debounces function execution
     * TODO: make shared utils lib
     * @param func
     * @param wait
     * @param immediate
     * @returns {Function}
     */
    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) {
                    func.apply(context, args);
                }
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) {
                func.apply(context, args);
            }
        };
    }

    /**
     * Throttles function execution. Based on Ben Alman implementation
     * TODO: make shared utils lib
     * @param delay
     * @param noTrailing
     * @param callback
     * @param atBegin
     * @returns {wrapper}
     */
    function throttle(delay, noTrailing, callback, atBegin) {
        var timeoutId;
        var lastExec = 0;

        if (typeof noTrailing !== 'boolean') {
            atBegin = callback;
            callback = noTrailing;
            noTrailing = undefined;
        }

        function wrapper() {
            var elapsed = +new Date() - lastExec;
            var args = arguments;

            var exec = function _exec() {
                lastExec = +new Date();
                callback.apply(this, args );
            }.bind(this);

            function clear() {
                timeoutId = undefined;
            }

            if (atBegin && !timeoutId) {
                exec();
            }

            timeoutId && clearTimeout(timeoutId);

            if (atBegin === undefined && elapsed > delay) {
                exec();
            } else if (noTrailing !== true) {
                timeoutId = setTimeout(
                    atBegin ?
                        clear :
                        exec,
                    atBegin === undefined ?
                    delay - elapsed :
                        delay
                );
            }
        }

        return wrapper;
    }

    function addAjaxNonce(data) {
        data['nonce_key'] = GLOBAL_DATA.nonce.nonceKey;
        data['nonce_value'] = GLOBAL_DATA.nonce.nonce;

        return data;
    }

    /**
     * Sends Google Analytics event, if API available
     * @param category
     * @param action
     * @param label
     * @param value
     */
    function trackGoogleAnalytics(category, action, label, value) {
        if (window.ga && typeof window.ga === 'function') {
            ga('send', 'event', category, action, label, value, {
                nonInteraction: true
            });
        }
    }

    // theme
    var ajaxUrl = GLOBAL_DATA.ajaxUrl;
    var $kbSearch = $('.kb-search__input');
    var NO_RESULTS_CLASS = 'kb-search__input-wrap--no-results';
    var HAS_CONTENT_CLASS = 'kb-search__input-wrap--has-content';
    var HAS_RESULTS_CLASS = 'kb-search__input-wrap--has-results';
    var REQUEST_CLASS = 'kb-search__input-wrap--request';
    var hasResults = false;
    var resultsCount = 0;
    var activeResult = -1;
    var ESC = 27;
    var ENTER = 13;
    var ARROW_LEFT = 37;
    var ARROW_UP = 38;
    var ARROW_RIGHT = 39;
    var ARROW_DOWN = 40;
    var $doc = $('html, body');
    var $adminBar;
    var adminOffset = 0;
    var searchMode = settings['search_mode'];
    var searchRequestsCount = 0;
    var searchCache = {};
    var trackingCache = {};

    /**
     * Live search result handler
     * @param $search
     * @param response
     */
    function handleSearchResultsReceive($search, response) {
        var $wrap = $search.parents('.kb-search__input-wrap');
        var $summary = $wrap.find('.kb-summary-text-holder');
        var $results = $wrap.find('.kb-search__results');
        var results = response.result;
        var searchNeedle = response.search;
        var resultsInfoHtml = response.results_info || '';
        var resultsContent;
        var searchShowTopics = $search.data('show-results-topic') === 1;
        var showTopicsLabel = $search.data('topic-label');

        if (searchMode === 'nonblocking') {
            var needle = $search.val() && $search.val().trim();

            if (!needle || needle.length < 3) {
                // in nonblocking mode user could have already removed the typed string

                results = [];
                hasResults = false;
                resultsCount = 0;
                activeResult = -1;
                $wrap.removeClass(HAS_RESULTS_CLASS).removeClass(NO_RESULTS_CLASS);
                $summary.html('');
                $results.html('');

                return;
            }
        }

        if (results && results.length) {
            if (settings['track_search_with_results']) {
                trackGoogleAnalytics(
                    settings['ga_good_search_category'],
                    settings['ga_good_search_action'],
                    searchNeedle,
                    settings['ga_good_search_value'] || 0
                );
            }

            hasResults = true;
            resultsCount = results.length;
            activeResult = -1;
            $wrap.removeClass(NO_RESULTS_CLASS).addClass(HAS_RESULTS_CLASS);
            $summary.html(results.length + ' ' + (results.length === 1 ? i18n['result'] : i18n['results']));
            resultsContent = results.reduce(function ($el, result) {
                return $el.append(
                    '<li>' +
                    '<a href="' + result.link + '">' +
                    '<span class="kb-search__result-title">' +
                    result.title +
                    '</span>' +
                    (searchShowTopics && result.topics[0] ?
                    '<span class="kb-search__result-topic">' +
                    '<span class="kb-search__result-topic-label">' + showTopicsLabel + '</span>' +
                    (result.topics[0]) +
                    '</span>' :
                        '') +
                    '</a>' +
                    '</li>'
                );
            }, $('<ul></ul>'));

            $results.html('');
            $results.append(resultsInfoHtml);
            $results.append(resultsContent);

        } else {
            if (settings['track_search_without_results']) {
                trackGoogleAnalytics(
                    settings['ga_bad_search_category'],
                    settings['ga_bad_search_action'],
                    searchNeedle,
                    settings['ga_bad_search_value'] || 0
                );
            }

            hasResults = false;
            resultsCount = 0;
            activeResult = -1;
            $wrap.removeClass(HAS_RESULTS_CLASS).addClass(NO_RESULTS_CLASS);
            $summary.html(i18n['no-results']);
            $results.html('');
        }
    }

    function focusInput() {
        $kbSearch.filter('[data-autofocus="1"]').focus();
    }

    function nextSearchResult() {
        var $resultItems = $('.kb-search__results li a');

        activeResult = activeResult + 1 >= resultsCount ? 0 : activeResult + 1;
        $resultItems.eq(activeResult).focus();
    }

    function prevSearchResult() {
        var $resultItems = $('.kb-search__results li a');

        activeResult = activeResult - 1 < 0 ? resultsCount - 1 : activeResult - 1;
        $resultItems.eq(activeResult).focus();
    }

    /**
     * Live search keypress handler
     * @param e
     */
    function onSearchKeyPress(e) {

        if (!$(".kb-search__input").is(":focus") && !$(".kb-search__results a").is(":focus")) {
            return; //we do not to mess with keypress unless search is in focus
        }

        var $search = $(".kb-search__input:focus");

        switch (e.keyCode) {
            case ESC:
                focusInput();
                break;

            case ARROW_UP:
                prevSearchResult();
                break;

            case ARROW_DOWN:
                nextSearchResult();
                break;

            case ENTER:
                if ($search.length && !$search.val().trim()) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                }
                return;

            default:
                return;
        }

        e.preventDefault(); // prevent the default action (scroll / move caret)
    }

    function serializeRequestParams(params) {
        var serialized = "";

        for (var key in params) {
            if (serialized !== "") {
                serialized += "&";
            }

            serialized += key + "=" + encodeURIComponent(params[key]);
        }

        return serialized;
    }

    /**
     * Search request stats is saved separately for non-blocking search
     */
    function trackSearchRequest(searchParams) {

        searchParams.trackResults = true;

        return $.ajax({
            method: 'POST',
            url: ajaxUrl,
            dataType: 'json',
            data: searchParams
        });
    }

    /**
     * Waits for a timeout untill tracking results
     * @param searchParams
     */
    var trackingTimerId = null;

    function handleNonBlockingTracking(searchParams) {
        var serializedParams = serializeRequestParams(searchParams);

        if (trackingTimerId) {
            clearTimeout(trackingTimerId);
        }

        if (trackingCache[serializedParams]) {
            return;
        }

        trackingTimerId = setTimeout(function() {
            trackSearchRequest(searchParams).then(function() {
                trackingCache[serializedParams] = true;
            });
        }, 1000);
    }

    /**
     * Lice search type handler
     * @param $search
     */
    function onSearchType($search) {
        var $wrap = $search.parents('.kb-search__input-wrap');
        var needle = $search.val() && $search.val().trim();
        var topics = $search.data('topic-ids');
        var $kbId = $wrap.find('input[name="kb_id"]');
        var kbId = $kbId.length ? parseInt($kbId.val()) : null;
        var searchParams = {
            action: 'mkb_kb_search',
            search: needle,
            mode: searchMode
        };

        if (kbId) {
            searchParams.kb_id = kbId;
        }

        if (topics) {
            searchParams.topics = topics;
        }

        var serializedParams = serializeRequestParams(searchParams);

        if (needle) {
            $wrap.addClass(HAS_CONTENT_CLASS);
        } else {
            $wrap.removeClass(HAS_CONTENT_CLASS);
        }

        // check cache for response
        if (settings['search_request_fe_cache'] && searchCache[serializedParams]) {
            // track cached result, if it wasn tracked before
            if (searchMode === 'nonblocking') {
                handleNonBlockingTracking(searchParams);
            }

            return handleSearchResultsReceive.call(this, $search, searchCache[serializedParams]);
        }

        if (!needle || needle.length < 3) {
            hasResults = false;
            resultsCount = 0;
            activeResult = -1;
            $wrap.removeClass(HAS_RESULTS_CLASS).removeClass(NO_RESULTS_CLASS);

            if (searchMode === 'nonblocking' && needle.length > 0) {
                fakeRequest($wrap); // progress indicator for input to be more responsive
            }

            return;
        }

        if (searchMode === 'nonblocking') {
            handleNonBlockingTracking(searchParams);
        }

        if (searchMode === 'blocking') {
            $search.attr('disabled', 'disabled');
        }

        $wrap.addClass(REQUEST_CLASS);
        ++searchRequestsCount;

        $.ajax({
            method: 'GET',
            url: ajaxUrl,
            dataType: 'json',
            data: searchParams
        })
            .then(function(response) {
                if (settings['search_request_fe_cache']) {
                    searchCache[serializedParams] = response;
                }

                return handleSearchResultsReceive.call(this, $search, response);
            }.bind(this))
            .always(function () {
                if (searchMode === 'blocking') {
                    $search
                        .attr('disabled', false)
                        .focus();
                }

                --searchRequestsCount;

                if (searchRequestsCount === 0) {
                    $wrap.removeClass(REQUEST_CLASS);
                }
            });
    }

    /**
     * Progress indicator for short requests
     * @param $wrap
     */
    function fakeRequest($wrap) {
        $wrap.addClass(REQUEST_CLASS);
        ++searchRequestsCount;

        setTimeout(function() {
            --searchRequestsCount;
            if (searchRequestsCount === 0) {
                $wrap.removeClass(REQUEST_CLASS);
            }
        }, 500);
    }

    /**
     * Article pageview tracking
     */
    function trackArticleView() {
        var $tracking_meta = $('.mkb-article-extra__tracking-data');

        if (!$tracking_meta.length) {
            return;
        }

        var $id = $tracking_meta.data('article-id');

        if (!$id) {
            return;
        }

        jQuery.ajax({
            method: 'POST',
            url: ajaxUrl,
            dataType: 'json',
            data: addAjaxNonce({
                action: 'mkb_article_pageview',
                id: $id
            })
        });
    }

    /**
     * Article like
     * @param e
     */
    function handleArticleLike(e) {
        e.preventDefault();

        var $likeBtn = $(e.currentTarget);
        var id = $likeBtn.data('article-id');
        var title = $likeBtn.data('article-title');
        var $count = $('.mkb-article-extra__stats-likes');
        var likes = parseInt($count.text(), 10);

        if (!id || $likeBtn.hasClass('mkb-voted') || $likeBtn.hasClass('mkb-disabled')) {
            return;
        }

        $likeBtn.addClass('mkb-voted');
        $('.mkb-article-extra__dislike').addClass('mkb-disabled');
        $count.text(++likes);

        jQuery.ajax({
            method: 'POST',
            url: ajaxUrl,
            dataType: 'json',
            data: addAjaxNonce({
                action: 'mkb_article_like',
                id: id
            })
        }).done(function() {
            if (settings['track_article_likes']) {
                trackGoogleAnalytics(
                    settings['ga_like_category'],
                    settings['ga_like_action'],
                    settings['ga_like_label'] === 'article_title' ? title : id,
                    settings['ga_like_value'] || 0
                );
            }

            if (settings['show_like_message']) {
                $('.fn-rating-likes-block')
                    .html($('<div class="mkb-article-extra__message">' + i18n['like_message_text'] + '</div>'));
            }

            if (settings['enable_feedback'] &&
                (settings['feedback_mode'] === 'like' || settings['feedback_mode'] === 'any')) {
                addFeedbackForm();
            }
        });
    }

    /**
     * Article dislike
     * @param e
     */
    function handleArticleDislike(e) {
        e.preventDefault();

        var $dislikeBtn = $(e.currentTarget);
        var id = $dislikeBtn.data('article-id');
        var title = $dislikeBtn.data('article-title');
        var $count = $('.mkb-article-extra__stats-dislikes');
        var dislikes = parseInt($count.text(), 10);

        if (!id || $dislikeBtn.hasClass('mkb-voted') || $dislikeBtn.hasClass('mkb-disabled')) {
            return;
        }

        $dislikeBtn.addClass('mkb-voted');
        $('.mkb-article-extra__like').addClass('mkb-disabled');
        $count.text(++dislikes);

        jQuery.ajax({
            method: 'POST',
            url: ajaxUrl,
            dataType: 'json',
            data: addAjaxNonce({
                action: 'mkb_article_dislike',
                id: id
            })
        }).done(function() {
            if (settings['track_article_dislikes']) {
                trackGoogleAnalytics(
                    settings['ga_dislike_category'],
                    settings['ga_dislike_action'],
                    settings['ga_dislike_label'] === 'article_title' ? title : id,
                    settings['ga_dislike_value'] || 0
                );
            }

            if (settings['show_dislike_message']) {
                $('.fn-rating-likes-block')
                    .html($('<div class="mkb-article-extra__message">' + i18n['dislike_message_text'] + '</div>'));
            }

            if (settings['enable_feedback'] &&
                (settings['feedback_mode'] === 'dislike' || settings['feedback_mode'] === 'any')) {
                addFeedbackForm();
            }
        });
    }

    /**
     * Renders feedback form if configured
     */
    function addFeedbackForm() {
        $.ajax({
            method: 'GET',
            url: ajaxUrl,
            dataType: 'json',
            data: addAjaxNonce({
                action: 'mkb_feedback_form'
            })
        }).done(function(response) {
            if (response.status == '0') {
                $('.fn-article-feedback-container').append(response.html);
            }
        });
    }

    /**
     * Sends article feedback to server
     * @param e
     */
    function handleFeedbackSubmit(e) {
        var $trackingMeta = $('.mkb-article-extra__tracking-data');

        e.preventDefault();

        if (!$trackingMeta.length) {
            return;
        }

        var id = $trackingMeta.data('article-id');
        var title = $trackingMeta.data('article-title');
        var $btn = $(e.target);
        var $content = $('.mkb-article-extra__feedback-form-message-area');

        if (!id || !$content.val()) {
            return;
        }

        $btn
            .text(i18n['feedback_submit_request_label'])
            .attr('disabled', 'disabled');

        jQuery.ajax({
            method: 'POST',
            url: ajaxUrl,
            dataType: 'json',
            data: addAjaxNonce({
                action: 'mkb_article_feedback',
                id: id,
                content: $content.val()
            })
        }).done(function() {
            if (settings['track_article_feedback']) {
                trackGoogleAnalytics(
                    settings['ga_feedback_category'],
                    settings['ga_feedback_action'],
                    settings['ga_feedback_label'] === 'article_title' ? title : id,
                    settings['ga_feedback_value'] || 0
                );
            }

            $('.fn-article-feedback-container').html(
                '<div class="mkb-article-extra__feedback-sent-message">' +
                i18n['feedback_sent_text'] +
                '</div>'
            );
        });
    }

    /**
     * Toggle submit available
     * @param e
     */
    function handleFeedbackType(e) {
        $('.fn-feedback-form').toggleClass('mkb-article-extra__feedback-form--no-content', Boolean($(e.currentTarget).val() < 1));
    }

    /**
     * Back to top in articles
     */
    function handleArticleBackToTop() {
        var $container = $('.mkb-container');

        $container.on('click', '.mkb-back-to-top', function (e) {
            e.preventDefault();

            $doc.animate({
                scrollTop: $container.offset().top - adminOffset
            }, 300);
        });
    }

    /**
     * Article Table of Contents
     */
    function handleArticleTOC() {
        var $entryContent = $('.mkb-single-content');
        var $tocList = $('.mkb-anchors-list');

        var $header = $('.site-header');
        var isStickyHeader = $body.hasClass('sticky-header');
        var mobileBreakpoint = settings['mobile_menu_breakpoint']['size'];
        var stickyHeaderOn = isStickyHeader && $body.width() > mobileBreakpoint;
        var headerHeight = $header.height();
        var stickyHeaderOffset = stickyHeaderOn ? headerHeight : 0;

        var scrollOffset = parseInt(settings['toc_scroll_offset']['size']) + adminOffset;
        var $headings;
        var isScrollSpy = settings['scrollspy_switch'] && settings['toc_in_content_disable'] &&
            platform === 'desktop' &&
            window.outerWidth >= parseInt(settings['article_sidebar_sticky_min_width']['size'], 10);

        // dynamic TOC
        if ($tocList.hasClass('mkb-anchors-list--dynamic')) {
            $headings = $entryContent.find('h1, h2, h3, h4, h5, h6');

            if (settings['show_back_to_top']) {
                wrapTOCAnchors($headings);
            }

        } else { // via shortcodes
            $headings = $('.mkb-anchor__title');
        }

        // scroll
        var headingOffsets = Array.prototype.map.call($headings, function(heading) {
            return $(heading).offset().top;
        });
        var $links = $tocList.find('.mkb-anchors-list__item-link');
        var linksArr = Array.prototype.map.call($links, function(link) {
            return link;
        }).filter(function(link) {
            return link.dataset.index !== '-1'; // other pages links
        });

        function recalculateMetrics() {
            headingOffsets = Array.prototype.map.call($headings, function(heading) {
                return $(heading).offset().top;
            });

            stickyHeaderOn = isStickyHeader && $body.width() > mobileBreakpoint;
            headerHeight = $header.height();
            stickyHeaderOffset = stickyHeaderOn ? headerHeight : 0;
        }

        $(window).on('load', recalculateMetrics);
        $(window).on('resize', debounce(recalculateMetrics, 1000));

        setTimeout(recalculateMetrics, 3000); // in case load fails

        var navScrolling = false;

        function navigateToChapter(index) {
            navScrolling = true;

            window.location.hash = 'ch_' + (index + 1);

            $doc.animate({
                scrollTop: headingOffsets[index] - scrollOffset - stickyHeaderOffset - 10
            }, 300, 'swing', function() {
                if (isScrollSpy && linksArr) {
                    $(linksArr).removeClass('active');
                    $(linksArr[index]).addClass('active');
                }

                setTimeout(function() {
                    navScrolling = false;
                }, 300);
            });
        }

        // link click handlers
        $tocList.on('click', '.mkb-anchors-list__item-link', function (e) {
            var $item = $(e.currentTarget);

            if ($item.attr('href') !== '#') {
                return; // normal link, just navigate
            }

            var index = parseInt($item.data('index'), 10);

            e.preventDefault();

            if (isScrollSpy) {
                $links.removeClass('active');
                $item.addClass('active');
            }

            navigateToChapter(index);
        });

        var chapterHash = window.location.hash && window.location.hash.replace(/^#/, '');

        if (chapterHash && chapterHash.indexOf('ch_') !== -1) {
            var chapterIndex = parseInt(chapterHash.replace(/^ch_/, '')) - 1;

            if (chapterIndex && chapterIndex > 0) {
                setTimeout(function() {
                    navigateToChapter(chapterIndex);
                }, 300);
            } else if (isScrollSpy && chapterIndex === 0) {
                $(linksArr[0]).addClass('active');
            }
        } else if (isScrollSpy) {
            $(linksArr[0]).addClass('active');
        }

        if (!isScrollSpy) {
            return;
        }

        // ScrollSpy
        var win = window;
        var doc = document.documentElement;

        $(win).on('scroll', throttle(150, function() {
            if (navScrolling) { return; }

            var top = (win.pageYOffset || doc.scrollTop) + stickyHeaderOffset;

            linksArr.forEach(function(item, index) {
                var curr = index === 0 ? 0 : headingOffsets[index] - scrollOffset - 1;
                var next = (index === headingOffsets.length - 1 ? 9999999 : headingOffsets[index + 1]) - scrollOffset - 1;

                $(item).toggleClass('active', top >= curr && top < next);
            });
        }));
    }

    /**
     * Wraps headings n back to top containers when necessary
     * @param $headings
     */
    function wrapTOCAnchors($headings) {
        $headings.each(function(index, el) {
            var $heading = $(el);

            $heading.wrap('<div class="mkb-anchor mkb-clearfix mkb-back-to-top-' +
            settings['back_to_top_position'] +
            '"></div>');

            $heading.addClass('mkb-anchor__title');

            $heading.parent().append('<a href="#" class="mkb-back-to-top" title="' +
            settings['back_to_top_text'] + '">' +
            settings['back_to_top_text'] +
            (
                settings['show_back_to_top_icon'] ?
                '<i class="mkb-back-to-top-icon fa ' + settings['back_to_top_icon'] + '"></i>' :
                    ''
            ) +
            '</a>');
        });
    }

    /**
     * Articles fancy box
     */
    function initArticlesFancyBox() {
        if (!$.fn.fancybox) {
            return;
        }

        // with captions
        $('figure[id^="attachment"] a').each(function (index, item) {
            var $item = $(item);
            var text = $item.parent().find('.wp-caption-text').text();

            $item.fancybox({
                titlePosition: 'over',
                title: text
            });
        });

        // no captions
        $('.mkb-single-content img').each(function(i, img) {
            var $img = $(img);
            var $link = $img.parent();

            if ($img.parents('figure.wp-caption').length || !$link.attr('href')) {
                return;
            }

            $link.fancybox({
                titlePosition: 'none',
                title: ''
            });
        });
    }

    /**
     * Search clear
     * @param e
     */
    function handleSearchClear(e) {
        e.preventDefault();

        $(e.currentTarget)
            .parents('.kb-search__input-wrap')
            .find('.kb-search__input')
            .val('')
            .trigger('input')
            .focus();
    }

    function initSearchInputs() {
        $kbSearch.each(function (index, el) {
            var $search = $(el);

            var searchHandler = searchMode === 'blocking' ?
                debounce(onSearchType.bind(this, $search), parseInt(settings['search_delay'], 10) || 1000, false) :
                throttle(parseInt(settings['search_delay'], 10) || 300, true, onSearchType.bind(this, $search), true);

            $search.on('input', searchHandler);
        });
    }

    /**
     * Detects if live search disabled for current platform
     * @returns {boolean}
     */
    function isSearchDisabled() {
        return Boolean(settings['live_search_disable_' + platform]);
    }

    /**
     * Sticky sidebar
     */
    function setupArticleStickySidebar() {

        if (!settings['article_sidebar_sticky'] ||
            !info.isSingle ||
            platform !== 'desktop' ||
            window.outerWidth < parseInt(settings['article_sidebar_sticky_min_width']['size'], 10)) {

            // sticky sidebar not enabled or not allowed
            return;
        }

        var sticky = false;
        var atBottom = false;
        var $sidebar = $('.sidebar');
        var $sidebarContent = $sidebar.find('.sidebar__content');
        var sidebarHeight = $sidebar.outerHeight();
        var sidebarHolderWidth = $sidebar.outerWidth();
        var $root = $sidebar.parents('.content-wrap');
        var rootHeight = $root.outerHeight();
        var rootHeightInner = $root.height();
        var rootPad = rootHeight - rootHeightInner;
        var rootTop = $root.offset().top;
        var triggerPos = rootTop - rootPad / 2;
        var winHeight = window.innerHeight;
        var bottomOffset = winHeight > sidebarHeight + rootPad ? winHeight - sidebarHeight - rootPad : 0;
        var width = $sidebar.outerWidth();
        var win = window;
        var doc = document.documentElement;
        var $adminBar = $('#wpadminbar');
        var adminOffset = $adminBar.length ? $adminBar.height() : 0;
        var $header = $('.site-header');
        var isStickyHeader = $body.hasClass('sticky-header');
        var mobileBreakpoint = settings['mobile_menu_breakpoint']['size'];
        var stickyHeaderOn = isStickyHeader && $body.width() > mobileBreakpoint;
        var headerHeight = $header.height();
        var stickyHeaderOffset = stickyHeaderOn ? headerHeight : 0;

        function recalculateMetrics() {
            stickyHeaderOn = isStickyHeader && $body.width() > mobileBreakpoint;
            headerHeight = $header.height();
            stickyHeaderOffset = stickyHeaderOn ? headerHeight : 0;
            rootHeight = $root.outerHeight();
            rootHeightInner = $root.height();
            rootPad = rootHeight - rootHeightInner;
            rootTop = $root.offset().top;
            triggerPos = rootTop - rootPad / 2 - adminOffset - stickyHeaderOffset;
            winHeight = window.innerHeight;
            sidebarHeight = $sidebarContent.outerHeight();
            sidebarHolderWidth = $sidebar.outerWidth();
            bottomOffset = winHeight > sidebarHeight + rootPad ? winHeight - sidebarHeight - rootPad : 0;
        }

        $(win).on('load', recalculateMetrics);
        $(win).on('resize', debounce(recalculateMetrics, 1000));

        setTimeout(recalculateMetrics, 3000); // in case load fails

        $(win).on('scroll', function() {
            var top = win.pageYOffset || doc.scrollTop;
            var bottom = top + winHeight - bottomOffset + adminOffset + stickyHeaderOffset;

            if (bottom > rootHeight + rootTop && !atBottom || bottom <= rootHeight + rootTop && atBottom) {
                atBottom = !atBottom;
                $sidebar.toggleClass('sidebar--fixed-bottom', atBottom);
                $sidebarContent.css('top', (atBottom ?
                    (rootHeight - sidebarHeight) + 'px' :
                    (sticky && stickyHeaderOn ? $header.height() + 'px' : '')
                ));
            }

            if (sticky && top >= triggerPos || !sticky && top < triggerPos) {
                return;
            }

            sticky = !sticky;
            $sidebar.toggleClass('sidebar--fixed', sticky);
            $sidebarContent.css('max-width', sticky ? width + 'px' : 'none');

            $sidebarContent.css('top', (sticky && stickyHeaderOn ? $header.height() + 'px' : ''));
        });
    }

    /**
     * FAQ
     */
    function setupFaq() {
        var $faqContainer = $('.fn-kb-faq-container');
        var MIN_NEEDLE_LENGTH = 2;

        if (!$faqContainer.length) {
            return;
        }

        $faqContainer.each(function(index, item) {
            var $container = $(item);
            var FAQ_HIDDEN_CLASS = 'mkb-faq-item-hidden';
            var FAQ_SECTION_HIDDEN_CLASS = 'mkb-faq-section-hidden';
            var $filterForm = $container.find('.fn-kb-faq-filter');
            var $filter = $filterForm.find('.fn-kb-faq-filter-input');
            var $sections = $container.find('.fn-kb-faq-section');
            var $noResults = $container.find('.fn-kb-faq-no-results');

            // FAQ sections
            var sections = [].map.call($sections, function(section) {
                var $section = $(section);
                var $count = $section.find('.fn-kb-faq-section-count');
                var $items = [].map.call($section.find('.fn-kb-faq-item'), function(item) {
                    var $item = $(item);
                    return {
                        $el: $item,
                        question: $item.find('.fn-kb-faq-question').text().trim().toLowerCase(),
                        answer: $item.find('.fn-kb-faq-answer').text().trim().toLowerCase(),
                        isVisible: true
                    };
                });

                return {
                    $el: $section,
                    $countEl: $count.length ? $count : null,
                    items: $items,
                    visible: [].map.call($items, function(item) { return $(item) }),
                    hidden: []
                }
            });

            /**
             * FAQ Filter
             */
            var currentFilter;

            function updateFilter(visCheck) {
                visCheck = visCheck || checkVisibility

                var totalVisible = 0

                // check visibility
                sections.forEach(function(section) {
                    section.visible = []
                    section.hidden = []
                    section.items.forEach(function(item) {
                        section[(item.isVisible = visCheck(item)) ? 'visible' : 'hidden'].push(item)
                    })
                    totalVisible += section.visible.length
                })

                $noResults.toggleClass('mkb-hidden', totalVisible > 0)

                sections.forEach(function(section) {
                    section.visible.forEach(function(item) {
                        item.$el.removeClass(FAQ_HIDDEN_CLASS)
                    })
                    section.hidden.forEach(function(item) {
                        item.$el.addClass(FAQ_HIDDEN_CLASS)
                    })
                    section.$countEl && section.$countEl.html(section.visible.length +
                    ' ' + (section.visible.length === 1 ? i18n['question'] : i18n['questions'])
                    )
                    section.$el.toggleClass(FAQ_SECTION_HIDDEN_CLASS, !section.visible.length)
                    section.visible = []
                    section.hidden = []
                })

                if (settings['faq_filter_open_single'] && totalVisible === 1) {
                    var $onlyItem = $container.find('.fn-kb-faq-item:not(.' + FAQ_HIDDEN_CLASS + ')')

                    if ($onlyItem.length && !$onlyItem.hasClass('kb-faq__questions-list-item--open')) {
                        toggleAnswer($onlyItem)
                    }
                }
            }

            var resetFilter = updateFilter.bind(this, function() { return true })

            function checkVisibility(item) {
                return item.question.indexOf(currentFilter) !== -1 || item.answer.indexOf(currentFilter) !== -1
            }

            function handleFilterChange(e) {
                var needle = (e.currentTarget.value || '').trim();

                if (needle.length < MIN_NEEDLE_LENGTH) {
                    $filterForm.addClass('kb-faq__filter--empty')
                    currentFilter = '';
                    resetFilter();

                    $filter.focus()
                    return
                }

                $filterForm.removeClass('kb-faq__filter--empty')
                currentFilter = needle.toLowerCase();
                updateFilter()
            }

            function handleFilterClear(e) {
                e.preventDefault()

                $filter.val('').trigger('input')
            }

            if ($filterForm.length) {
                $container.on('input', '.fn-kb-faq-filter-input', handleFilterChange)
                $container.on('click', '.fn-kb-faq-filter-clear', handleFilterClear)
            }

            /**
             * FAQ Toggle
             */
            function toggleAnswer($item) {
                var $answer = $item.find('.fn-kb-faq-answer')

                if ($item.hasClass('kb-faq__questions-list-item--open')) {
                    $answer.css('max-height', $answer.outerHeight())
                    $answer.animate({maxHeight: 0}, 100, 'swing', function() {
                        $answer.css('display', 'none')
                        $item.removeClass('kb-faq__questions-list-item--open')
                    })
                } else {
                    $answer.animate({maxHeight: $answer.outerHeight()}, 100, 'swing', function() {
                        $answer.css('max-height', 'none')
                        $item.addClass('kb-faq__questions-list-item--open')
                    })
                    $answer.css('display', 'block')
                }
            }

            function openAnswer($item) {
                var $answer = $item.find('.fn-kb-faq-answer')

                if (!$item.hasClass('kb-faq__questions-list-item--open')) {
                    $answer.animate({maxHeight: $answer.outerHeight()}, 100, 'swing', function() {
                        $answer.css('max-height', 'none')
                        $item.addClass('kb-faq__questions-list-item--open')
                    })
                    $answer.css('display', 'block')
                }
            }

            function closeAnswer($item) {
                var $answer = $item.find('.fn-kb-faq-answer')

                if ($item.hasClass('kb-faq__questions-list-item--open')) {
                    $answer.css('max-height', $answer.outerHeight())
                    $answer.animate({maxHeight: 0}, 100, 'swing', function() {
                        $answer.css('display', 'none')
                        $item.removeClass('kb-faq__questions-list-item--open')
                    })
                }
            }

            function handleQuestionClick (e) {
                e.preventDefault();

                var $link = $(e.currentTarget)
                var $item = $link.parent()

                toggleAnswer($item)
            }

            function handleToggleAllClick (e) {
                e.preventDefault()

                var $link = $(e.currentTarget)
                var isOpen = $link.hasClass('kb-faq__toggle-all-link--open')

                sections.forEach(function(section) {
                    section.items.forEach(function(item) {
                        isOpen ? closeAnswer(item.$el) : openAnswer(item.$el)
                    })
                })

                $link.toggleClass('kb-faq__toggle-all-link--open')
            }

            $container.on('click', '.fn-kb-faq-link', handleQuestionClick)
            $container.on('click', '.fn-kb-faq-toggle-all', handleToggleAllClick)
        });
    }

    function stickyHeader() {
        var STICKY_POINT = 300;
        var header = $('.site-header')[0];
        var doc = document.documentElement;
        var stickyActive = false;

        $(window).on('scroll', throttle(100, false, function() {
            if (!stickyActive && doc.scrollTop >= STICKY_POINT) {
                header.classList.add('sticky-active');
                stickyActive = true;
            } else if (stickyActive && doc.scrollTop < STICKY_POINT) {
                header.classList.remove('sticky-active');
                stickyActive = false;
            }
        }));
    }

    function setupContentTreeWidgets() {
        var $contentTree = $('.mkb_content_tree_widget');

        function setListMaxHeight(index, list) {
            var $list = $(list);
            $list.animate({'max-height': list.scrollHeight}, 200, function() {
                $list.css('max-height', 'none');
            });
        }

        $contentTree.each(function(index, tree) {
            var $tree  = $(tree);
            var $topics = $tree.find('.mkb-widget-content-tree__topic');

            $topics.on('click', function(e) {

                if (e.target.tagName.toLowerCase() === 'a') {
                    return; // skip article link clicks
                }

                var topic = e.currentTarget;
                var $topic = $(topic);

                if ($topic.hasClass('topic-open')) {
                    $topic.removeClass('topic-open');
                    $topic.find('>ul').css('max-height', '0');
                } else {
                    var activeBranch = [topic.dataset.id];
                    var $parents = $topic.parents('.mkb-widget-content-tree__topic');

                    $parents.each(function(index, parent) {
                        activeBranch.push(parent.dataset.id);
                    });

                    $topics.each(function(index, item) {
                        if (activeBranch.indexOf(item.dataset.id) !== -1) {
                            return;
                        }

                        var $item = $(item);

                        $item.removeClass('topic-open');
                        $item.find('>ul').css('max-height', '0');
                    });
                    $topic.find('>ul').each(setListMaxHeight);
                    $topic.addClass('topic-open');

                    $parents.each(function(index, item) {
                        if ($topic.hasClass('topic-open')) {
                            return;
                        }

                        $(item).find('>ul').each(setListMaxHeight);
                        $topic.addClass('topic-open');
                    });
                }

                e.preventDefault();
                e.stopImmediatePropagation();
            });
        });
    }

    /**
     * Simple responsive gallery
     */
    function simpleGallery() {
        nobs('.content', {
            prev: '<i class="fa fa-angle-left"></i>',
            next: '<i class="fa fa-angle-right"></i>'
        });
    }

    /**
     * Mobile navigation
     */
    function mobileNav() {
        var $toggle = $('.fn-mobile-nav-toggle');
        var $navContent = $('.fn-mobile-nav-content');
        var mobileBreakpoint = settings['mobile_menu_breakpoint']['size'];

        $toggle.on('click', function(e) {
            e.preventDefault();

            $navContent.toggleClass('nav-open');
        });

        $navContent.on('click', '.menu-item-has-children > a', function(e) {
            var $link = $(e.currentTarget);
            var $item = $link.parent();

            $item.toggleClass('sub-menu-open');

            e.preventDefault();
        });

        function setMobileClass() {
            $body.toggleClass('theme-mobile-nav', $body.width() <= mobileBreakpoint);
        }

        $(window).on('resize', setMobileClass);
        $(window).on('orientationchange', setMobileClass);

        setMobileClass();
    }

    function init() {
        $adminBar = $('#wpadminbar');
        adminOffset = $adminBar.length ? $adminBar.height() : 0;

        var $body = $('body');

        if ($kbSearch.length && !isSearchDisabled()) {
            initSearchInputs();
            $body.on('keydown', onSearchKeyPress);
            $body.on('click', '.kb-search__clear', handleSearchClear);
            focusInput();
            onSearchType($kbSearch.eq(0)); // restore previous search
        }

        // FAQ items
        setupFaq();

        // article related code
        if (info.isSingle) {
            $body.on('click', '.mkb-article-extra__like', handleArticleLike);
            $body.on('click', '.mkb-article-extra__dislike', handleArticleDislike);
            $body.on('click', '.mkb-article-extra__feedback-form-submit a', handleFeedbackSubmit);
            $body.on('input', '.mkb-article-extra__feedback-form-message-area', handleFeedbackType);

            handleArticleBackToTop();
            handleArticleTOC();

            if (settings['article_fancybox']) {
                initArticlesFancyBox();
            }

            // single
            trackArticleView();

            // sticky articles sidebar
            setupArticleStickySidebar();
        }

        setupContentTreeWidgets();

        if (settings['header_sticky_switch']) {
            stickyHeader();
        }

        $('.content').fitVids();

        simpleGallery();
        mobileNav();
    }

    // start
    $(document).ready(init);

})(jQuery);